module.exports = __webpack_public_path__ + "img/pic-left.66744719.svg";